import React from "react";

const AllCountriesSkeleton = ({ isDarkMode }) => {
  // Generate random widths for more realistic skeleton
  const getRandomWidth = (min = 40, max = 80) =>
    `${Math.floor(Math.random() * (max - min + 1)) + min}%`;

  return (
    <div className="rounded-[6px] bg-white dark:bg-bluedarkmodecolor shadow-dashboardshadow mt-[12px]">
      {/* Header Skeleton */}
      <div className="dropdown-block flex items-center justify-between rounded-[6px_6px_0px_0px] p-[8px_10px] xl:p-[8px_15px] bg-darkblue dark:bg-bluedarkmode">
        <div className="skeleton-shimmer h-[18px] w-[120px] bg-white/20 rounded"></div>
        <div className="skeleton-shimmer h-[15px] w-[15px] xl:h-[19px] xl:w-[19px] bg-white/20 rounded"></div>
      </div>

      {/* Countries Skeleton */}
      <div className="country-block">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="country-item">
            {/* Country Header Skeleton */}
            <div className="flex justify-between py-2 px-3 s18:p-[10px_14px] border-b-[1px] border-solid border-bordercolor">
              <div className="flex items-center flex-1">
                <div
                  className="skeleton-shimmer h-[14px] bg-gray-200 dark:bg-darktitleColor rounded mr-2"
                  style={{ width: getRandomWidth(30, 60) }}
                ></div>
                <div className="skeleton-shimmer h-[12px] w-[60px] bg-gray-200 dark:bg-darktitleColor rounded"></div>
              </div>

              <div className="flex items-center">
                <div className="skeleton-shimmer h-[12px] w-[20px] bg-gray-200 dark:bg-darktitleColor rounded mr-2"></div>
                <div className="skeleton-shimmer h-[12px] w-[12px] xl:h-[15px] xl:w-[15px] bg-gray-200 dark:bg-darktitleColor rounded"></div>
              </div>
            </div>

            {/* Randomly show expanded leagues for some countries */}
            {(index === 1 || index === 3 || index === 5) && (
              <div className="leagues-list bg-gray-50 dark:bg-darktitleColor border-b-[1px] border-solid border-bordercolor">
                {[...Array(Math.floor(Math.random() * 4) + 1)].map(
                  (_, leagueIndex) => (
                    <div
                      key={leagueIndex}
                      className="league-item flex justify-between items-center py-2 px-6 s18:p-[8px_20px] border-b-[1px] border-solid border-gray-200 dark:border-gray-700 last:border-b-0"
                    >
                      <div
                        className="skeleton-shimmer h-[12px] bg-gray-300 dark:bg-darktitlehovercolor rounded"
                        style={{ width: getRandomWidth(40, 85) }}
                      ></div>

                      <div className="flex items-center">
                        <div className="skeleton-shimmer h-[12px] w-[15px] bg-gray-300 dark:bg-darktitlehovercolor rounded mr-2"></div>
                        <div className="skeleton-shimmer w-2 h-2 bg-gray-300 dark:bg-darktitlehovercolor rounded-full"></div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* CSS for shimmer animation */}
      <style jsx>{`
        .skeleton-shimmer {
          background: linear-gradient(
            90deg,
            currentColor 25%,
            transparent 37%,
            transparent 63%,
            currentColor 75%
          );
          background-size: 400% 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: 100% 50%;
          }
          100% {
            background-position: -100% 50%;
          }
        }

        .dark .skeleton-shimmer {
          opacity: 0.7;
        }
      `}</style>
    </div>
  );
};

export default AllCountriesSkeleton;
